<template>
  <div class="skills-select-box">
    <h4
      v-if="name && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback }"
    >
      <b>{{name}}{{required ? '*' : ''}}</b>
    </h4>
    <p
      v-if="description && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }"
    >
        {{description}}
    </p>
    <b-form-group :label="settings.noHeader ? name : ($root.isCXR ? null : 'Skills')">
      <multiselect
        :value="value"
        @input="input($event)"
        :close-on-select="false"
        :clear-on-select="true"
        :preserve-search="false"
        :options="selectOptions"
        :multiple="true"
        :loading="$apollo.queries.taxonomyOptions.loading"
        @search-change="onSearch"
        :placeholder="this.$root.isCXR ? 'Start typing a discipline...' : 'Start typing a skill...'"
        class="multiselect-rlnx"
      >
        <template v-slot:noResult>Skill not found, try something similar</template>
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SearchTaxonomySkillsQuery from '@/graphql/queries/SearchTaxonomySkills.gql';
import SearchTaxonomyJobRelatedSkillsQuery from '@/graphql/queries/SearchTaxonomyJobRelatedSkills.gql';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => null,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    jobTitleID: {
      type: String,
      default: null,
    },
    isFreeText: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
    searchTerm: '',
    searchTermTimeout: null,
    newTerms: [],
  }),
  apollo: {
    relatedSkills: {
      query: SearchTaxonomyJobRelatedSkillsQuery,
      variables() {
        const { jobTitleID } = this;
        return { jobTitleID };
      },
      update({ company: { taxonomyTitles } = {} }) {
        if (!Array.isArray(taxonomyTitles) && !taxonomyTitles.length) return [];
        const relatedSkills = taxonomyTitles[0] && Array.isArray(taxonomyTitles[0].skills) ? taxonomyTitles[0].skills : [];
        return relatedSkills.reduce((out, { name, alternateNames }) => {
          if (!out.includes(name)) out.push(name);
          if (Array.isArray(alternateNames)) {
            alternateNames.forEach(el => {
              if (!out.includes(el)) out.push(el);
            });
          }
          return out;
        }, []).sort((a, b) => a.length - b.length);
      },
      skip() {
        return !this.jobTitleID || Array.isArray(this.options);
      },
      fetchPolicy: 'network-only',
      error(err) {
        this.$log.error(err);
      },
    },
    taxonomyOptions: {
      query: SearchTaxonomySkillsQuery,
      variables() {
        const { searchTerm } = this;
        return { searchTerm };
      },
      update({ company: { taxonomySkills } }) {
        const { relatedSkills } = this;
        const filteredRelatedSkills = Array.isArray(relatedSkills) ? relatedSkills.filter(el => {
          if (this.searchTerm && this.searchTerm.length >= 2) {
            return el.toLowerCase().includes(this.searchTerm.toLowerCase());
          }
          return true;
        }) : [];
        return Array.isArray(taxonomySkills) ? taxonomySkills.reduce((out, { name, alternateNames }) => {
          if (!out.includes(name)) out.push(name);
          if (Array.isArray(alternateNames)) {
            alternateNames.forEach(el => {
              if (!out.includes(el)) out.push(el);
            });
          }
          return out;
        }, filteredRelatedSkills)
          .sort((a, b) => a.length - b.length) : filteredRelatedSkills;
      },
      skip() {
        return !this.searchTerm || this.searchTerm.length < 2 || Array.isArray(this.options);
      },
      fetchPolicy: 'network-only',
      error(err) {
        this.$log.error(err);
      },
    },
  },
  computed: {
    backendOptions() {
      const { options, searchTerm, taxonomyOptions, relatedSkills } = this;
      let backendOptions = [];
      if (options && options.length) {
        backendOptions = options;
      } else if (searchTerm.length > 2) {
        backendOptions = taxonomyOptions || [];
      } else {
        backendOptions = relatedSkills || [];
      }

      return backendOptions;
    },
    selectOptions() {
      const { backendOptions, searchTerm, isFreeText } = this;
      if (isFreeText && searchTerm.length > 1 && !backendOptions.map(
        el => el.toLowerCase()).includes(searchTerm.toLowerCase())
      ) {
        return [
          searchTerm,
          ...backendOptions,
        ];
      }

      return backendOptions;
    },
  },
  methods: {
    onSearch(val) {
      clearTimeout(this.searchTermTimeout);
      this.searchTermTimeout = setTimeout(() => {
        this.searchTerm = val;
      }, 500);
    },
    input(input) {
      const { isFreeText, backendOptions, selectOptions, searchTerm } = this;
      const newItem = input[input.length - 1];
      console.log('CURRENT STATE: ', { isFreeText, backendOptions, selectOptions });
      if (isFreeText && newItem === searchTerm && !backendOptions.includes(searchTerm)) {
        this.newTerms.push(searchTerm);
      }
      this.newTerms = this.newTerms.filter(term => input.indexOf(term) > -1);
      console.log('NEW TERMS: ', this.newTerms);
      if (isFreeText) {
        this.$emit('input', { input, newTerms: this.newTerms });
      } else {
        this.$emit('input', input);
      }
    },
  }
};
</script>

<style lang="scss">
.skills-select-box {
  .multiselect-rlnx {
    .multiselect__tags {
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/JobSkillsSelector.vue